import * as React from 'react';
import antd, { Layout } from 'antd';
import { Row, Col } from 'antd';
// import moment = require("moment");
import { NavLink, Link } from 'react-router-dom';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import SslSealBadge from '../SslSealBadge';
import ConfigUtility from 'Core/ConfigUtility';



export interface Props {
  children?: React.ReactNode;
}

export interface State { }

const colStyle = { textAlign: 'left' };

const hyperLinkStyle = {
  color: '#ffffff',
};

export default class Footer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const { Footer } = Layout;
    const config = ConfigUtility.getSync();
    const year = moment(Date.now())
      .format('YYYY')
      .toString();

    return (
      <Footer style={{ backgroundColor: '#1A1E23', marginTop: '15px' }}>
        <Row style={{ textAlign: 'left' }} type="flex">
          <Col xs={{ span: 24 }} lg={{ span: 3 }}>
            <a style={hyperLinkStyle} href="#">
              Copyright &copy; {year}
            </a>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 2 }}>
            <a style={hyperLinkStyle} href="https://kingstonwharves.com/about-us/who-we-are/">
              About Us
            </a>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 3 }}>
            <Link style={hyperLinkStyle} to="/terms">
              Terms &amp; Conditions
            </Link>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 4, offset: 2 }}>
            <a style={hyperLinkStyle} hidden href="#">
              FAQs
            </a>
          </Col>
          <Col style={{ background: 'white', display: 'flex', justifyContent: 'space-between' }} xs={{ span: 24 }} lg={{ span: 6, offset: 2 }}>
            <SslSealBadge />
          </Col>
        </Row>
        <Row style={{ textAlign: 'left' }} type="flex">
          <Col xs={{ span: 24 }} lg={{ span: 3 }} >
            <Link style={hyperLinkStyle} to="/privacy-policy">
              {config?.AppVersion}
            </Link></Col>
          <Col xs={{ span: 24 }} lg={{ span: 2 }}>
            <a style={hyperLinkStyle} href="https://kingstonwharves.com/contacts/">
              Contact Us
            </a>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 3 }}>
            <Link style={hyperLinkStyle} to="/privacy-policy">
              Privacy Policy
            </Link>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 4, offset: 2 }} />
          <Col xs={{ span: 24 }} lg={{ span: 6, offset: 2 }} />
        </Row>
      </Footer>
    );
  }
}
